import { render, staticRenderFns } from "./lkuJenisIklandigital.vue?vue&type=template&id=29333f07"
import script from "./lkuJenisIklandigital.vue?vue&type=script&lang=js"
export * from "./lkuJenisIklandigital.vue?vue&type=script&lang=js"
import style0 from "./lkuJenisIklandigital.vue?vue&type=style&index=0&id=29333f07&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports